export const fiscalData = {
	title: "FISCAL DATA",
	fields: {
		ncm: {
			label: "NCM",
			placeholder: "Enter NCM",
			tooltip: "Common Mercosur Nomenclature",
		},
		cest: {
			label: "CEST",
			placeholder: "Enter CEST",
			tooltip: "Tax Substitution Specifier Code",
		},
		fiscalProfile: {
			label: "Fiscal profile",
			placeholder: "Select fiscal profile",
			loading: "Loading...",
			tooltip: "Set of data that describes the tax situation of a person or company.",
		},
		fiscalGroup: {
			label: "Fiscal group",
			placeholder: "Select fiscal group",
			loading: "Loading...",
			tooltip:
				"Fiscal group is a code that classifies products according to their taxation.",
		},
	},
};
